import { Injectable } from '@angular/core';
import * as signalR from "@microsoft/signalr";
import { Notification } from '../core/models/notification.model';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from '../core/authencation/auth.service';
import { FileSaverService } from 'ngx-filesaver';
import { getBaseUrl } from './helpers';

const notificationMsgLimit = 10;

@Injectable({
  providedIn: 'root',
})

export class NotificationService {
  public data: any[] = [];
  public countUnread: number = 0;
  private hubConnection: signalR.HubConnection;

  isAuthenticated = false;

  constructor(private http: HttpClient, private authService: AuthService, private _FileSaverService: FileSaverService) {
    console.log("init hub");
    this.init();
  }

  private init() {
    this.authService.isLoggedIn.subscribe(
      (isAuthorized: boolean) => {
        this.isAuthenticated = isAuthorized;
        console.log('Authorized:' + this.isAuthenticated);
        if (isAuthorized) {
          const url = getBaseUrl() + "notificationHub";
          const token = this.authService.token;
          console.debug("baseURL: " + url);
          console.debug("token: " + token);
          this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(url, {
              accessTokenFactory: () => token,
              // skipNegotiation: true,
              // transport: signalR.HttpTransportType.WebSockets,
              // withCredentials: true
            })
            .withAutomaticReconnect()
            .build();

          this.connect();

          this.hubConnection.onclose(() => {
            this.connect();
          });
        }
      }
    );
  }

  private connect() {
    this.hubConnection.start()
      .then(() => {
        console.log("Connection Start");
        this.registerListener();

        this.loadNotification();
      })
      .catch(err => {
        console.log("error start hub: " + err);
      });
  }

  private hubConnected() {
    return this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected;
  }

  public registerListener() {
    if (this.hubConnection != null) {
      this.hubConnection.on("ReceiveNotification", (data) => {
        this.data = data.map(value => {
          return {
            title: value.title,
            message: value.message,
            read: value.read,
            actions: JSON.parse(value.actions),
            id: value.id
          }
        });
        this.countUnread = this.data.filter(value => value.read == false).length;
      });

      this.hubConnection.on('ReceiveNewNotification', (data: any) => {
        var newData = {
          title: data.title,
          message: data.message,
          read: data.read,
          actions: JSON.parse(data.actions),
          id: data.id
        };

        var idx = this.data.findIndex(o => o.id == newData.id);
        if (idx >= 0) this.data.splice(idx, 1);

        this.data.unshift(newData);
        if (this.data.length > notificationMsgLimit) this.data.pop();
        this.countUnread = this.data.filter(value => value.read == false).length;
      });
    }
  }

  public loadNotification = () => {
    if (this.hubConnected()) {
      this.hubConnection.invoke('LoadNotification')
        .catch(err => console.error(err));
    }
  }


  public readNotification = () => {
    if (this.hubConnection != null) {
      this.hubConnection.invoke('ReadNotificationByUserName')
        .catch(err => console.error(err.toString()));
    }
  }

  httpOption = {
    headers: new HttpHeaders({
      "Content-Type": "application/json; chatset=utf-8",
    }),
  };
  public doNotificationAction(data: any) {
    if (data.requestType == 'Get') {
      if (data.dataType == 'File') {
        this.http
          .get(data.requestUri, { responseType: 'blob', observe: 'response' })
          .subscribe(
            res => {
              let fileName = 'file';
              const contentDisposition = res.headers.get('Content-Disposition');
              if (contentDisposition) {
                const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                const matches = fileNameRegex.exec(contentDisposition);
                fileName = matches[1].replace(/['"]/g, '');
                if (matches != null && matches[1]) {
                  fileName = matches[1].replace(/['"]/g, '');
                }
              }
              this._FileSaverService.save((<any>res).body, fileName);
            },
            err => {
              console.log(err);
              alert('Download fail !');
            },
            () => console.log('HTTP request completed.'),
          );
      }
      else if (data.dataType == 'LinkNoAuth') {
        const headers = new HttpHeaders({
          'Accept': '*/*',
          'NoAuthorization': 'true'
        });

        this.http.get(data.requestUri, { headers, responseType: 'blob' })
          .subscribe(
            res => {
              let fileName = data.fileName;
              this._FileSaverService.save(res, fileName);
            },
            err => {
              console.log(err);
              alert('Download fail !');
            },
            () => console.log('HTTP request completed.')
          );
      }
      else {
        this.http
          .get(data.requestUri).subscribe(res => {

          });
      }
    } else {
      this.http
        .post(data.requestUri, data.requestData, this.httpOption)
        .subscribe((data) => {
          console.log(data.toString());
        });
    }
  }
}
